export default "__VITE_ASSET__DhFvdzca__"